module.exports = __webpack_public_path__ + "static/media/ts_help4.d60e9cca.png";